module.exports = __webpack_public_path__ + "media/images/country_flags/id-56cecf1066c8f4963579eab507b1646c.png";